import * as types from "./types";

export const getAdminEventRequestsRequest = (payload) => ({
  type: types.GET_ADMIN_EVENT_REQUESTS_REQUEST,
  payload,
});

export const getAdminEventRequestsResponse = (payload) => ({
  type: types.GET_ADMIN_EVENT_REQUESTS_RESPONSE,
  payload,
});

export const getAdminEventRequestsSummaryResponse = (payload) => ({
  type: types.GET_ADMIN_EVENT_REQUESTS_SUMMARY_RESPONSE,
  payload,
});

export const bulkApproveAdminEventRequestsRequest = (payload) => ({
  type: types.BULK_APPROVE_ADMIN_EVENT_REQUESTS_REQUEST,
  payload,
});

export const bulkRejectAdminEventRequestsRequest = (payload) => ({
  type: types.BULK_REJECT_ADMIN_EVENT_REQUESTS_REQUEST,
  payload,
});

export const bulkAllocateAdminEventRequestsRequest = (payload) => ({
  type: types.BULK_ALLOCATE_ADMIN_EVENT_REQUESTS_REQUEST,
  payload,
});

export const bulkUnassignAdminEventRequestsRequest = (payload) => ({
  type: types.BULK_UNASSIGN_ADMIN_EVENT_REQUESTS_REQUEST,
  payload,
});

export const bulkRemoveAdminEventRequestsRequest = (payload) => ({
  type: types.BULK_REMOVE_ADMIN_EVENT_REQUESTS_REQUEST,
  payload,
});

export const bulkChangeRoleAdminEventRequestsRequest = (payload) => ({
  type: types.BULK_CHANGE_ROLE_ADMIN_EVENT_REQUESTS_REQUEST,
  payload,
});
